import styled from 'styled-components';
import { Outlet } from 'react-router-dom';

import { Footer, Header } from '@ciam/ui';

import { useEffect, type HTMLAttributes } from 'react';

export interface AuthLayoutProps extends HTMLAttributes<HTMLElement> {
  marginTop: string;
}

export const AuthLayout = ({ marginTop, ...props }: AuthLayoutProps) => {
  useEffect(() => {
    // URL에 t 파라미터가 없는 경우에만 새로고침
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('t')) {
      // 현재 timestamp를 t 파라미터로 추가
      urlParams.set('t', Date.now().toString());
      // 새로운 URL로 리다이렉트 (새로고침)
      window.location.href = `${window.location.pathname}?${urlParams.toString()}`;
    }
  }, []);

  return (
    <>
      <Header />
      <Main $marginTop={marginTop} {...props}>
        <Outlet />
      </Main>
      <Footer page="login" />
    </>
  );
};

const Main = styled.main<{ $marginTop: AuthLayoutProps['marginTop'] }>`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${({ $marginTop }) => $marginTop};
`;
